<template>
  <div class="flex-1 overflow-hidden" ref="main">
    <q-card class="fit flex flex-col overflow-hidden shadow-sm">
      <q-card-section style="height: 68px" class="flex justify-between">
        <q-btn
          color="primary"
          icon="add"
          label="Add New"
          @click="isOpen = true"
        />

        <assets-select
          style="z-index: 99999"
          v-if="manualAsset == ''"
          @selected="
            (v) => {
              newAsset = v;
            }
          "
          :singleSelect="true"
          :f="{
            groupBy: 'assetGroup',
            text: 'assetName',
            value: 'assetId',
          }"
          ref="assetSelect"
          :isLegacy="true"
        />
        <q-dialog v-model="isOpen">
          <q-card style="width: 500px" class="p-2">
            <q-card-section>
              <div class="text-h6">Add New Vehicle</div>
            </q-card-section>

            <q-card-section class="q-pt-none">
              <span v-if="manualAsset == ''">
                Select vehicle from the list
              </span>

              <assets-select
                v-if="manualAsset == ''"
                @selected="
                  (v) => {
                    newAsset = v;
                  }
                "
                :singleSelect="true"
                :f="{
                  groupBy: 'assetGroup',
                  text: 'assetName',
                  value: 'assetId',
                }"
                ref="assetSelect"
                :isLegacy="true"
              />
              <div
                style="height: 1px"
                class="w-full my-5"
                v-if="manualAsset == '' && newAsset == ''"
              ></div>
              <div class="w-full pt-4" v-if="newAsset == ''">
                Or manual add vehicle not in the list
              </div>
              <div
                class="pt-4 flex gap-4 flex-center px-2"
                v-if="newAsset == ''"
              >
                <span>Registration Number</span>
                <vs-input class="flex-1" size="small" v-model="manualAsset" />
              </div>
              <!-- <div>{{ newAsset }}</div> -->
            </q-card-section>

            <q-card-actions align="right">
              <q-btn flat label="Cancel" color="danger" v-close-popup />
              <q-btn
                label="Add Vehicle"
                color="primary"
                v-close-popup
                @click="addNewVehicle()"
              />
            </q-card-actions>
          </q-card>
        </q-dialog>
        <div class="">
          <div
            class="relative mr-4"
            ref="target"
            style="height: 30px; width: 250px"
          >
            <input
              v-model="search"
              type="text"
              placeholder="Search Asset Name"
              class="fit rounded-full pl-4 pr-10"
              style="border: solid 1px black"
              @input="$emit('search', search)"
            />
            <q-icon
              :name="search.trim() == '' ? 'search' : 'close'"
              class="absolute right-0 cursor-pointer"
              :class="{ 'mr-2': search.trim() != '' }"
              :size="search.trim() == '' ? '26px' : '20px'"
              style="
                top: 50%;
                transform: translate(-5px, -50%);
                transition: 0.2s;
              "
              @click="
                search = '';
                $emit('search', search);
              "
            />
          </div>
        </div>
      </q-card-section>
      <q-card-section
        class="overflow-hidden flex-1 w-full"
        style="min-width: 0"
      >
        <div class="fit" style="container-type: inline-size">
          <q-table
            v-if="store.list"
            flat
            :data="filteredData"
            :columns="columns"
            row-key="name"
            style="width: 100cqw"
            class="h-full"
          >
            <template #header="props">
              <q-tr :props="props">
                <q-th
                  v-for="col in props.cols"
                  :key="col.name"
                  :props="props"
                  style="z-index: 999"
                >
                  <span
                    class="font-bold capitalize"
                    v-if="!['brand'].includes(col.field)"
                  >
                    {{ col.label }}
                  </span>
                </q-th>
                <q-th class="font-bold capitalize text-center" key="action">
                  Actions
                </q-th>
              </q-tr>
            </template>
            <template #body="props">
              <q-tr
                :props="props"
                @click="$emit('selected', props.row)"
                :class="{ 'bg-blue-1': props.row.id == selected }"
              >
                <q-td style="width: 30px" class="px-2" key="brand">
                  <q-avatar size="30px" square>
                    <img
                      class="object-contain"
                      v-if="props.row.brand"
                      :src="`https://www.carlogos.org/car-logos/${props.row.brand
                        .toLowerCase()
                        .replace(/\s+/g, '-')}-logo.png`"
                      alt=""
                    />
                    <q-tooltip content-class="bg-black">
                      {{ props.row.brand }}
                    </q-tooltip>
                  </q-avatar>
                </q-td>
                <q-td
                  v-for="col in props.cols"
                  :key="col.field"
                  :props="props"
                  v-if="!['brand', 'actions'].includes(col.field)"
                >
                  <span v-if="!['create_time'].includes(col.field)">
                    {{ props.row[col.name] }}
                  </span>

                  <div
                    v-if="col.field == 'create_time'"
                    class="flex flex-col items-start break-words whitespace-normal gap-1"
                    style="max-width: 8vw"
                  >
                    <span class="flex flex-no-wrap gap-2 text-xs font-bold">
                      <q-badge color="white" style="border-radius: 50px">
                        <q-icon
                          name="calendar_today"
                          color="purple"
                          size="8px"
                        />
                      </q-badge>
                      {{ props.row['create_time'].split(' ')[0] }}
                    </span>
                    <span class="flex flex-no-wrap gap-2 text-xs">
                      <q-badge color="white" style="border-radius: 50px">
                        <q-icon name="schedule" color="teal" size="9px" />
                      </q-badge>
                      {{ props.row['create_time'].split(' ').at(-1) }}
                    </span>
                  </div>
                </q-td>
                <q-td
                  key="actions"
                  class="text-center flex flex-center gap-2"
                  style="min-width: 112px"
                >
                  <q-btn
                    color="primary"
                    icon="edit_square"
                    flat
                    padding="none"
                    class="no-underline"
                    :to="{
                      path: $route.fullPath,
                      query: { asset: props.row.id },
                    }"
                  >
                    <q-tooltip content-class="bg-black">
                      Edit / View Details
                    </q-tooltip>
                  </q-btn>
                  <q-btn
                    color="danger"
                    icon="delete"
                    flat
                    padding="none"
                    @click="
                      deleteFleet(props.row.id);
                      $emit('selected', null);
                    "
                  >
                    <q-tooltip content-class="bg-black"> Delete </q-tooltip>
                  </q-btn>
                </q-td>
              </q-tr>
            </template>
          </q-table>
          <div v-else class="relative h-full w-full flex flex-col flex-center">
            <q-inner-loading
              :showing="true"
              label="Please wait..."
              label-class="text-teal"
              label-style="font-size: 1.1em"
            />
          </div>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch, nextTick } from 'vue';
import { store } from '../api/api';
import { useRoute, useRouter } from 'vue-router/composables';

import AssetsSelect from '../../map-view/AssetsSelect.vue';

const props = defineProps({
  // data: {},
  // chart: {},
  // loading: {},
  // visibleColumns: {},
  // scrollSizeItem: { default: 90 },
  selected: { default: '' },
});

const route = useRoute();
const router = useRouter();
const main = ref();

const search = ref('');

const filteredData = computed(() => {
  if (search.value.trim() != '') {
    let val = search.value.trim();
    const needle = val.toLowerCase();
    return store.list.filter((v) => v.name.toLowerCase().indexOf(needle) > -1);
  } else {
    return store.list;
  }
});

const newAsset = ref();
const manualAsset = ref();

async function addNewVehicle() {
  console.log('called');

  let id = -1;
  let assetName = manualAsset.value;
  let manual = true;
  if (
    newAsset.value &&
    newAsset.value[0] != null &&
    newAsset.value[0] != undefined
  ) {
    id = newAsset.value[0];
    manual = false;
  }
  console.log(id, assetName, manual);
  try {
    let response = await store.addNewVehicle(id, assetName, manual);
    if (response == 'success') {
      main.value.__vue__.$vs.notify({
        title: 'Success',
        text: 'New Asset has been added',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success',
      });
      setTimeout(() => {
        router.push({
          path: route.fullPath,
          query: { asset: store.list.at(-1).id },
        });
      }, 100);
    } else {
      throw response.data.error;
    }
  } catch (e) {
    console.log(e);
    main.value.__vue__.$vs.notify({
      title: 'Error',
      text: e,
      iconPack: 'feather',
      icon: 'icon-refresh-cw',
      color: 'warning',
    });
  }
}

async function deleteFleet(fleetId) {
  await store.removeFleet(fleetId, main.value);
}
// onMounted(async () => {
//   await nextTick();
//   await store.getMainPageDev();
// });
const cols = [
  'brand',
  ['name', 'Asset'],
  'type',
  'model',
  ['create_time', 'Added Date'],
  // 'actions',
];
const columns = computed(() => {
  const arr = [];
  cols.forEach((e) => {
    let obj = {};
    if (Array.isArray(e)) {
      obj = {
        name: e[0],
        label: e[1],
        field: e[0],
      };
    } else {
      obj = {
        name: e,
        label: e,
        field: e,
      };
    }
    arr.push({ ...obj, ...{ align: 'left', sortable: true } });
  });
  return arr;
});

const isOpen = ref(false);
watch(isOpen, () => {
  if (isOpen.value) {
    newAsset.value = '';
    manualAsset.value = '';
  }
});
</script>

<style lang="scss" scoped></style>
